import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    
    // Автоматически перезагружаем страницу при ошибке загрузки чанка
    if (error && error.name === 'ChunkLoadError') {
      console.warn('ChunkLoadError detected, reloading page...');
      // Небольшая задержка перед перезагрузкой, чтобы пользователь увидел сообщение
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const isChunkError = this.state.error?.name === 'ChunkLoadError' || 
                           this.state.error?.message?.includes('Loading chunk');
      
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
          <div className="text-center max-w-md">
            <AlertCircle className="h-16 w-16 text-red-600 dark:text-red-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              {isChunkError ? 'Обновление приложения' : 'Что-то пошло не так'}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              {isChunkError 
                ? 'Обнаружена новая версия приложения. Страница будет автоматически перезагружена...'
                : 'Извините, произошла ошибка. Пожалуйста, попробуйте обновить страницу или свяжитесь с поддержкой, если проблема сохраняется.'}
            </p>
            {!isChunkError && (
              <button
                onClick={this.handleReset}
                className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center space-x-2 mx-auto"
              >
                <RefreshCw className="h-5 w-5" />
                <span>Обновить страницу</span>
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;